import React from 'react';
import { AlertTriangle, RefreshCw, Utensils } from 'lucide-react';

export function RestaurantSkeletons({ count = 6 }) {
  return (
    <div className="rc-card-grid" aria-label="Cargando contenido" aria-busy="true">
      {Array.from({ length: count }, (_, index) => (
        <div className="rc-skeleton-card" key={index}>
          <span className="rc-skeleton rc-skeleton--image" />
          <span className="rc-skeleton rc-skeleton--title" />
          <span className="rc-skeleton rc-skeleton--line" />
          <span className="rc-skeleton rc-skeleton--short" />
        </div>
      ))}
    </div>
  );
}

export function RestaurantEmptyState({
  title,
  message,
  actionLabel,
  onAction,
  error = false
}) {
  const Icon = error ? AlertTriangle : Utensils;
  return (
    <div className={`rc-empty ${error ? 'rc-empty--error' : ''}`} role={error ? 'alert' : 'status'}>
      <span className="rc-empty__icon"><Icon aria-hidden="true" /></span>
      <h2>{title}</h2>
      <p>{message}</p>
      {actionLabel && (
        <button type="button" className="rc-button rc-button--secondary" onClick={onAction}>
          {error && <RefreshCw aria-hidden="true" />}
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export function RestaurantToast({ toast, onClose }) {
  if (!toast) return null;
  return (
    <div className={`rc-toast rc-toast--${toast.type || 'info'}`} role="status">
      <div>
        <strong>{toast.title}</strong>
        {toast.message && <p>{toast.message}</p>}
      </div>
      <button type="button" aria-label="Cerrar aviso" onClick={onClose}>×</button>
    </div>
  );
}
